export function getCookie (name) {
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  let arr = document.cookie.match(reg)
  if (arr) {
    return unescape(arr[2])
  } else {
    return null
  }
}
export function setCookie (cookieName, value, expiredays, path, domain) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = cookieName + '=' + escape(value) +
     ((expiredays == null) ? '' : '; expires=' + exdate.toGMTString()) +
     ((path == null) ? '' : '; path=' + escape(path)) +
     ((domain == null) ? '' : '; domain=' + escape(domain))
}



// WEBPACK FOOTER //
// ./src/common/js/cookie.js